import { useTheme } from "@mui/material";
import { FileIcon } from "~components/Icons";
import { getStyles } from "../styles";

interface Props {
  isCompleted: boolean;
  filename: string;
}

const Completed = ({ isCompleted, filename }: Props) => {
  const theme = useTheme();
  const { styles } = getStyles(theme, isCompleted);

  return (
    <div style={styles.wrapper}>
      <FileIcon />
      <div style={styles.content}>
        <p style={styles.title}>{filename}</p>
        <p style={styles.text}>Carregamento concluído</p>
      </div>
    </div>
  );
};

export default Completed;
